export default __webpack_public_path__ + "static/mowing-cceb04e438a51c4a306edb1ae6101012.webp";